import { AppointmentStatus } from '@bb/domain/dist/types';
import { Button, Icon, theme, Tooltip } from 'components';
import React from 'react';
import styled from 'styled-components';
import { AgentCalendarMenu, ShowingCalendarMenuOption } from '../../types';
import { getPrintLink } from '../../utils';

export type PrintButtonProps = {
  date: string;
  listingId?: string;
  statuses: AppointmentStatus[];
  selectedMenuOption: ShowingCalendarMenuOption;
  dataCy?: string;
};

const ICON_SIZE = 16;

const PrintButton: React.FC<PrintButtonProps> = ({
  date,
  listingId,
  statuses,
  selectedMenuOption,
  dataCy,
}) => {
  const isBuyer = selectedMenuOption === AgentCalendarMenu.Buyer;
  const tooltipChildren = (
    <Button
      size="small"
      noBorder
      ghost
      href={getPrintLink(selectedMenuOption, {
        date,
        preferences: statuses,
        listingId,
      })}
      rel="noopener noreferrer"
      target="_blank"
      data-cy={dataCy}
    >
      <Icon
        type="antdPrinterFilled"
        width={ICON_SIZE}
        height={ICON_SIZE}
        color="gray8"
      />
    </Button>
  );

  return (
    <Tooltip
      placement="topRight"
      arrowPointAtCenter
      title={`Print${isBuyer ? ' showings' : ''}`}
    >
      {tooltipChildren}
    </Tooltip>
  );
};

export default PrintButton;
